import updateSearchFields from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/UpdateSearchFields";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import searchFilterAccessorials from "@tKgpco/Handlers/Accessorials/SearchFilterAccessorials";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";
import { AccessorialsFormValues } from "@tKgpco/Store/Data/Accessorials/AccessorialsState";
import searchFilterSecurityRoles from "@tKgpco/Store/Data/SecurityRoles/Handlers/SearchFilterRoles";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const mapStateToProps = (state: CustomApplicationState) => ({
    pagination: state.KGPState.SecurityRolesStore.pagination,
    selectFilter: state.KGPState.SecurityRolesStore.selectFilter,
    selectFilterText: state.KGPState.SecurityRolesStore.selectFilterText,
});

const mapDispatchToProps = {
    searchFilterSecurityRoles,
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RolesPaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const rolesPaginationStyles: RolesPaginationStyles = {};

const styles = rolesPaginationStyles;

const RolesPagination = ({ searchFilterSecurityRoles, pagination, selectFilter, selectFilterText }: Props) => {
    if (!pagination) {
        return null;
    }
    const [shouldScrollToTop, setShouldScrollToTop] = useState(false);
    useEffect(() => {
        if (shouldScrollToTop) {
            window.scrollTo(0, 0);
            setShouldScrollToTop(false);
        }
    }, [pagination?.page]);

    const { totalItemCount, page, pageSize, pageSizeOptions, prevPageUri, nextPageUri } = pagination;
    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        searchFilterSecurityRoles({
            page: newPageIndex,
            [selectFilter as keyof AccessorialsFormValues]: selectFilterText,
        });
        setShouldScrollToTop(true);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        // updateSearchFields({
        //     page: 1,
        //     pageSize: newPageSize,
        // });

        searchFilterSecurityRoles({
            page: 1,
            pageSize: newPageSize,
        });
    };

    return (
        <Pagination
            {...styles.pagination}
            resultsCount={totalItemCount}
            currentPage={page}
            resultsPerPage={pageSize}
            resultsPerPageOptions={pageSizeOptions}
            onChangePage={changePage}
            onChangeResultsPerPage={changeResultsPerPage}
            prevPage={prevPageUri}
            nextPage={nextPageUri}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RolesPagination),
    definition: {
        displayName: "Roles Pagination",
        group: "Basic",
    },
};

export default widgetModule;
